import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  TextContainer,
  Toast,
  Checkbox,
  FormLayout,
  ChoiceList,
  Filters,
  TextField,
  Badge,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import Pagination from "@material-ui/lab/Pagination";
import { useNavigate } from "react-router-dom";

const Campaigns = () => {
  const navigate = useNavigate();
  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "");
  const addEditState = useRef("");
  const perPage = 200;
  const [ts, setTs] = useState("");
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [items, setItems] = useState([]);
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const handleAddCampaign = () => {
    addEditState.current = "add-campaign";
    setCampaignNameValue("");
    setCampaignSlugValue("");
    setCheckedIsDefault(false);
    setActiveAddEdit(true);
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    // {
    //   key: "availability",
    //   label: "Filter by",
    //   filter: (
    //     <ChoiceList
    //       title="Filter by"
    //       titleHidden
    //       choices={[{ label: "Name", value: "name" }]}
    //       selected={availability || []}
    //       onChange={handleAvailabilityChange}
    //     />
    //   ),
    //   shortcut: true,
    // },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = isLoading ? <Loading /> : null;
  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <img src={emptyListImage}></img>
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  useEffect(() => {
    getData();
  }, [ts, availability, queryValue]);
  const getData = () => {
    axios
      .get(
        `/crm/campaigns?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }${
          queryValue
            ? `&filter[${
                availability === "" ? "name" : availability
              }]=${queryValue}`
            : ""
        }`
      )
      .then((result) => {
        !result.data.data.data.length
          ? setIsListEmpty(true)
          : setIsListEmpty(false);
        setItems(
          result.data.data.data.map((item, index) => [
            <div className="row_click2">{item?.name && item.name}</div>,
            <div className="row_click2">
              {item.is_default ? <Badge>Default</Badge> : ""}
            </div>,
            <div className="me-3">
              <ButtonGroup>
                <Button onClick={() => handleEdit(item)}>Edit</Button>
                <Button destructive onClick={() => handleDelete(item.id)}>
                  Delete
                </Button>
              </ButtonGroup>
            </div>,
          ])
        );
        setIsLoading(false);
      })
      .catch(function (error) {
        if (error.response) {
        }
      });
  };
  const [checkedIsDefault, setCheckedIsDefault] = useState(false);
  const handleChangeIsDefault = (newValue) => {
    setCheckedIsDefault(newValue);
  };
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This campaign has been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const clickedCampaign = useRef(null);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    clickedCampaign.current = id;
    setActiveDelete(true);
  };
  const handleEdit = (item) => {
    console.log(item);
    addEditState.current = "edit-campaign";
    clickedCampaign.current = item;
    setCampaignNameValue(item.name);
    // setCampaignSlugValue(item.slug);
    setActiveAddEdit(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    const form_data = new FormData();
    form_data.append("is_active", 0);
    axios
      .delete(`/crm/campaigns/${clickedCampaign.current}`, form_data)
      .then((result) => {
        setToastContent("This campaign has been successfully deleted");
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const [campaignNameValue, setCampaignNameValue] = useState("");
  const handleChangeCampaignName = (value) => {
    setCampaignNameValue(value);
    setCampaignNameError("");
  };
  const [campaignSlugValue, setCampaignSlugValue] = useState("");
  const handleChangeCampaignSlug = (value) => {
    setCampaignSlugValue(value);
  };
  const [campaignNameError, setCampaignNameError] = useState("");
  const [activeAddEdit, setActiveAddEdit] = useState(false);
  const handleChangeModalAddEdit = useCallback((activeAddEdit) => {
    setActiveAddEdit(!activeAddEdit);
    setIsSaving(false);
  }, []);
  const handleSubmitAddEdit = () => {
    if (!campaignNameValue) {
      setCampaignNameError("This field is required");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("name", campaignNameValue);
      form_data.append("slug", slugify(campaignNameValue));
      addEditState.current === "edit-campaign" &&
        form_data.append("_method", "PATCH");
      let url =
        addEditState.current === "add-campaign"
          ? `/crm/campaigns`
          : `/crm/campaigns/${clickedCampaign.current.id}`;
      axios
        .post(url, form_data)
        .then((result) => {
          setToastContent(
            addEditState.current === "add-campaign"
              ? `This campaign has been successfully added`
              : "Changes have been saved successfully"
          );
          toggleActive();
          setIsSaving(false);
          setActiveAddEdit(false);
          setTs(+new Date());
        })
        .catch((err) => console.log(err));
    }
  };
  return (
    <Page
      title="Campaigns"
      primaryAction={
        <Button variant="primary" onClick={handleAddCampaign}>
          Add Campaign
        </Button>
      }
      backAction={{ onAction: () => navigate("/admin/crm/contacts") }}
      fullWidth
    >
      <Card padding="0">
        {loadingMarkup}
        <Filters
          queryValue={queryValue}
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        />
        <DataTable
          columnContentTypes={["text", "text", "text", "text"]}
          headings={[
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Name
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Code
            // </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
          ]}
          rows={items}
          verticalAlign="middle"
          increasedTableDensity
        />
        {emtyState}
        {totalPages >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              count={totalPages}
              page={page}
              onChange={handleChangePage}
              size="large"
            />
          </div>
        )}
        {/* <Modal
          open={activeModal}
          onClose={handleChangeModal}
          title="Add Campaign"
          primaryAction={{
            content: "Submit",
            onAction: handleSubmitModal,
            loading: isSaving,
          }}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: handleChangeModal,
              loading: isSaving,
            },
          ]}
        >
          <Modal.Section>
            <FormLayout>
              <Select
                label="Campaign"
                placeholder="Please select"
                options={countryList}
                onChange={handleSelectChangeCampaign}
                value={selectedCampaign}
                error={campaignError}
              />
            </FormLayout>
          </Modal.Section>
        </Modal> */}

        <Modal
          open={activeDelete}
          onClose={handleChangeModalDelete}
          title="Delete Campaign"
          primaryAction={{
            content: "Yes",
            onAction: handleYesDelete,
            loading: isSaving,
          }}
          secondaryActions={[
            {
              content: "No",
              loading: isSaving,
              onAction: handleChangeModalDelete,
            },
          ]}
        >
          <Modal.Section>
            <TextContainer>
              <p>Are you sure you want to delete this campaign?</p>
            </TextContainer>
          </Modal.Section>
        </Modal>

        <Modal
          open={activeAddEdit}
          onClose={handleChangeModalAddEdit}
          title={`${
            addEditState.current === "add-campaign" ? "Add" : "Edit"
          } Campaign`}
          primaryAction={{
            content: "Submit",
            onAction: handleSubmitAddEdit,
            loading: isSaving,
          }}
          secondaryActions={[
            {
              content: "Cancel",
              loading: isSaving,
              onAction: handleChangeModalAddEdit,
            },
          ]}
        >
          <Modal.Section>
            <FormLayout>
              <TextField
                label="Name"
                value={campaignNameValue}
                onChange={handleChangeCampaignName}
                error={campaignNameError}
              />
              {/* <TextField
                label="Slug"
                value={campaignSlugValue}
                onChange={handleChangeCampaignSlug}
              /> */}
            </FormLayout>
          </Modal.Section>
        </Modal>
        {toastMarkup}
      </Card>
    </Page>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      // case "productType":
      //   return value.join(", ");
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
};

export default Campaigns;
